import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Input } from 'antd'

import { useTranslation } from 'react-i18next'

import { Drawer } from 'antd'

import Icon from '../Icon'
import './index.less'

const MobileSearch = () => {
  const { t } = useTranslation()
  const history = useHistory()
  // const searchRef = useRef()
  const [visible, setVisible] = useState(false)
  const [value, setValue] = useState('')

  const onClick = () => {
    setVisible(!visible)
  }

  const handleKeyUp = () => {
    value &&
      history.push({
        pathname: '/search',
        state: { value },
      })
  }

  useEffect(() => {
    setValue('')
  }, [visible])
  return (
    <div className="mobile-search-container">
      <Icon onClick={onClick} type="icon-search" className="search-icon" />
      <Drawer
        placement="right"
        closable={false}
        visible={visible}
        getContainer={false}
        className="mobile-search-drawer"
      >
        <Icon rotate={90} onClick={onClick} type="icon-arrow-down" className="back-icon" />
        <Input
          value={value}
          bordered={false}
          onPressEnter={handleKeyUp}
          onChange={(e) => {
            setValue(e.target.value)
          }}
          ref={(input) => {
            if (input != null) {
              input.focus({
                cursor: 'end',
              })
            }
          }}
          placeholder={t('home.search_text')}
          // suffix={<Icon onClick={onClick} type="icon-search" className="search-icon" />}
        />
        {/* <input placeholder={t('home.search_text')} type="search" ref={searchRef} onKeyUp={handleKeyUp} /> */}
      </Drawer>
    </div>
  )
}

export default MobileSearch
